import { FC } from 'react';

import { VSpacing } from '@hh.ru/magritte-ui';

import { useSelector } from 'src/hooks/useSelector';

import Gallery from 'src/components/VacancySearchContent/components/VacancyWizard/Magritte/Gallery';
import Header from 'src/components/VacancySearchContent/components/VacancyWizard/Magritte/Header';

const VacancySearchWizard: FC = () => {
    const { totalEmployersFound } = useSelector((state) => state.vacancyWizard);

    if (totalEmployersFound === 0) {
        return null;
    }

    return (
        <div data-qa="vacancy-search-wizard">
            <Header />
            <VSpacing default={12} />
            <Gallery />
            <VSpacing default={24} />
        </div>
    );
};

export default VacancySearchWizard;
